"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _Button = _interopRequireDefault(require("./Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BlockWithHeader = function BlockWithHeader(_ref) {
  var ribbonContent = _ref.ribbonContent,
      headerContent = _ref.headerContent,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
      _ref$buttonSubText = _ref.buttonSubText,
      buttonSubText = _ref$buttonSubText === void 0 ? null : _ref$buttonSubText,
      _ref$onButtonClick = _ref.onButtonClick,
      onButtonClick = _ref$onButtonClick === void 0 ? function () {} : _ref$onButtonClick,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = BlockWithHeader;
exports["default"] = _default;